// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseQueryResult } from '@tanstack/react-query';
import { EndInvestorOnboardingRequest } from '@daml.js/dtc-registry-app/lib/Dtc/Registry/App/V3/Service/Onboarding';
import TemplateContract from '../../../../utils/TemplateContract';
import { useOperatorBasedQuery } from '../../useOperatorBasedQuery';

const useEndInvestorOnboardingRequests: () => UseQueryResult<
  TemplateContract<EndInvestorOnboardingRequest>[],
  string
> = () =>
  useOperatorBasedQuery('queryEndInvestorOnboardingRequests', (ledgerApi, offset, operator) =>
    ledgerApi.queryEndInvestorOnboardingRequests(offset, operator),
  );

export default useEndInvestorOnboardingRequests;
